import token from "./token"
import tokenAjax from "./token-ajax"
import tokenRouter from "./token-router"

const params = {
    logoutCallback: null
}


async function getAccessKey() {
    return await Vue.prototype.GLOBAL.api.$root.get("/web/token/accessKey").then((res) => {
        res = res.data;
        if (res.status == "200") {
            if (res.data) {
                return res.data
            } else {
                return false
            }
        } else {
            return false
        }
    }).catch(() => {
        console.error("获取资源失败")
        return false
    })
}

export default {
    config({ logoutCallback, router }) {
        tokenAjax.config(logoutCallback)
        tokenRouter.config(router, logoutCallback)
        Object.assign(params, { logoutCallback })
    },
    logout() {
        token.clearToken();
        if (params.logoutCallback) params.logoutCallback.call(this)
    },
    getAccessKey() {

        return getAccessKey();
    }
}